<template>
  <v-container class="mt-4">
    <v-row></v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'LoginRouteBranch',
  props: [],
  data: function() {
    return {}
  },
  computed: {
    ...mapGetters('auth', ['isLogined', 'userMap', 'isRoleSuper', 'isRoleAgency', 'isRoleAdvertiser'])
  },
  methods: {
    ...mapActions('auth', ['getSession']),

    async initialize() {
      try {
        await this.getSession();

        if (this.isLogined) {
          const userMap = this.userMap;
          const agencyId = isNumber(userMap['custom:agencyId']) ? userMap['custom:agencyId'] : '0';
          const advertiserId = isNumber(userMap['custom:advertiserId']) ? userMap['custom:advertiserId'] : '0';

          if (this.isRoleSuper) {
            this.$router.replace('/agencyList').catch(() => {
              this.$router.go(0);
            });
          } else if (this.isRoleAgency) {
            this.$router.replace('/advertiserList/' + agencyId).catch(() => {
              this.$router.go(0);
            });
          } else if (this.isRoleAdvertiser) {
            this.$router.replace('/campaignPeriodList/' + agencyId + '/' + advertiserId);
          }
        } else {
          this.$router.replace('/login');
        }
      } catch (error) {
        this.$router.replace('/login');
      }
    }
  },
  mounted: function() {
    this.initialize();
  }
}
const isNumber = function(value) {
  if (typeof value !== 'number' && typeof value !== 'string') return false
  else return typeof parseFloat(value) === 'number' && isFinite(value)
}
</script>
